export default {
  fetchURL: 'https://gumex.hu/wp/wp-json/wp/v2'
};